import { Input } from '@components/core-ui/form-elements/Input';
import ErrorIcon from '@components/icons/FormError.svg';
import DoneCheckmarkIcon from '@components/icons/DoneCheckmark.svg';
import { useId } from 'react';
import { cn } from '@helpers/cn';
import { getSlugStatusMessage } from './helpers/getSlugStatusMessage';
import { TProps } from './types/TProps';

export const SlugField = ({
  label,
  value,
  onChange,
  status,
  name = 'slug',
  disabled = false,
  className,
  onRetry,
}: TProps) => {
  const hintId = useId();
  const reportedStatus = disabled ? 'idle' : status;
  const isError = reportedStatus === 'taken' || reportedStatus === 'invalid' || reportedStatus === 'error';

  const adornment = (
    <span>
      {reportedStatus === 'checking' ? (
        <span className="block size-5 animate-spin rounded-full border-2 border-spinner-track border-t-spinner-gradient-end" />
      ) : null}
      {reportedStatus === 'available' ? (
        <DoneCheckmarkIcon className="block size-5 text-success" aria-hidden="true" focusable="false" />
      ) : null}
      {isError ? <ErrorIcon className="block size-5" aria-hidden="true" focusable="false" /> : null}
    </span>
  );

  return (
    <div className={className}>
      <Input
        label={label}
        name={name}
        value={value}
        disabled={disabled}
        error={isError}
        adornment={adornment}
        aria-describedby={hintId}
        onChange={(e) => onChange(e.target.value)}
      />
      <p
        id={hintId}
        className={cn(
          'text-xs leading-5 text-foreground-muted empty:h-5',
          reportedStatus === 'available' && 'text-success',
          isError && 'text-error',
        )}
        aria-live="polite"
      >
        {disabled ? '' : getSlugStatusMessage(status)}
        {reportedStatus === 'error' && onRetry ? (
          <button type="button" className="ml-1 underline underline-offset-2 hover:text-foreground" onClick={onRetry}>
            Try again
          </button>
        ) : null}
      </p>
    </div>
  );
};
